<template>
	<div class="container hide">
        <p>{{ msg }} {{display }}</p>
    </div>
</template>

<script>

export default {
    name: "LeafletMapLoader",
    props: {
        msg: String,
        display: Boolean
    },
    data: function () {
        return {};
    },
    watch: {
        display: function (newVal, oldVal) {
            if(newVal !== oldVal) {
                console.log('Display for loader is: ' + newVal);
            }
        }
    },
    mounted () { 

    }
}
</script>

<style scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 700px;
  background-color: #00000085;
  position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 10000;
}
.container.hide {
    display: none;
}
.container > p {
    animation: animate 3s linear infinite;
    background: -webkit-gradient(linear, left top, right top, from(#000), color-stop(#fff), to(#000));
    background: linear-gradient(90deg, #aed581, #fff, #aed581);
    background-clip: text;
    background-repeat: no-repeat;
    background-size: 80%;
    position: relative;
    font-family: 'Material Design Icons';
    text-transform: uppercase;
    font-size: 3em;
    letter-spacing: 2px;
    overflow: hidden;
    -webkit-animation: animate 3s linear infinite;
    -webkit-background-clip: text;
    -webkit-text-fill-color: rgba(255, 255, 255, 0);
}

@keyframes animate {
  0% {
    background-position: -500%;
  }
  100% {
    background-position: 500%;
  }
}
</style>